import type { ExtendedConstraints, CapabilityConfig } from '../../../types';
import { hasValue } from '../../../utils';
import * as AppletSpec from '../applet/applet';

export type Applet = AppletSpec.Applet;

export const id = 'headless-applet';

export enum Events {
  CustomEvent = 'headless-applet:custom-event',
}
export enum Actions {
  Attach = 'headless-applet:attach',
  Detach = 'headless-applet:detach',
  CustomAction = 'headless-applet:custom-action',
}

export type CustomEventPayload = unknown;
export type CustomActionPayload = unknown;

const VALID_CONFIG_KEYS = [...AppletSpec.VALID_CONFIG_KEYS, 'attach'] as const;
export type Config = AppletSpec.Config & {
  type: typeof id;
  attach?: boolean;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
  eventPayloadTuple: [Events.CustomEvent, CustomEventPayload];
  eventHandlerTuple: [
    Events.CustomEvent,
    (payload: CustomEventPayload) => void,
  ];

  actionPayloadTuple:
    | [Actions.Attach]
    | [Actions.Detach]
    | [Actions.Attach, AppletSpec.AppletPayload]
    | [Actions.Detach, AppletSpec.AppletPayload]
    | [Actions.CustomAction, CustomActionPayload];
}>;

export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!AppletSpec.isValidConfig(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  const isAttachNotValid =
    hasValue(config, 'attach') && typeof config.attach !== 'boolean';

  if (isAttachNotValid) {
    return false;
  }

  return true;
}
